import Button from "@mui/material/Button";
import { memo } from "react";

import AppIcon from "@/components/Core/AppIcon";
import Translations from "@/components/Core/Translations";

interface LoginButtonProps {
  onClick: () => void;
  /**
   * Opens the form on its sign-up side. Given, a second button is shown for
   * it: on a wide screen a visitor is offered both ways in, rather than a
   * login form with sign-up a tab inside it.
   */
  onRegister?: () => void;
}

export const LoginButton = memo(({ onClick, onRegister }: LoginButtonProps) => (
  <>
    <Button
      // With sign-up beside it, logging in is the quieter of the two.
      variant={onRegister ? "outlined" : "contained"}
      color="primary"
      size="small"
      onClick={onClick}
      sx={{ gap: 1, borderRadius: 999, px: 2, whiteSpace: "nowrap" }}
    >
      <AppIcon name="user" size={16} />
      <Translations text="header.login" />
    </Button>
    {onRegister && (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={onRegister}
        sx={{ borderRadius: 999, px: 2, whiteSpace: "nowrap" }}
      >
        <Translations text="header.register" />
      </Button>
    )}
  </>
));
LoginButton.displayName = "LoginButton";
